export default __webpack_public_path__ + "static/circle-packing-f32ddd8e0d2cc33cb3e1a751c530b43b.png";